<template>
    <a class="amazing-tooltip">
        <icon name="question-circle"></icon>
        <span class="help-size">
            <strong>{{ title }}</strong>
            <br><div v-html="description"></div>
            <div v-if="auxhref"><a target="_blank" :href="auxhref">{{hreflabel}}</a></div>
        </span>
    </a>
</template>

<script>
    export default {
        props: ['title', 'description', 'auxhref', 'hreflabel']
    }
</script>



// WEBPACK FOOTER //
// FormHelp.vue?3ff027ee